import { Component, OnInit, ViewChild, ViewEncapsulation } from '@angular/core';
import {
  Diagram,
  NodeModel,
  ConnectorModel,
  SnapConstraints,
  SnapSettingsModel,
  DataBinding,
  HierarchicalTree,
  DiagramTools,
  ISelectionChangeEventArgs,
  IEndChangeEventArgs,
  cloneArray,
  NodeConstraints,
} from '@syncfusion/ej2-diagrams';
import { DataManager } from '@syncfusion/ej2-data';
import { MatDialog } from '@angular/material/dialog';
import { HierarchieModifModalComponent } from '../hierarchie-modif-modal/hierarchie-modif-modal.component';
import { DiagramComponent } from '@syncfusion/ej2-angular-diagrams';
import { data } from 'autoprefixer';
import { GeneralService } from 'src/app/services/general.service';
import { forkJoin, Observable } from 'rxjs';
import { map } from 'rxjs/operators';
export interface DataInfo {
  [key: string]: string;
}

Diagram.Inject(DataBinding, HierarchicalTree);

@Component({
  selector: 'app-ajouter-hierarchie',
  templateUrl: './ajouter-hierarchie.component.html',
  styleUrls: ['./ajouter-hierarchie.component.scss'],
  encapsulation: ViewEncapsulation.None,
})
export class AjouterHierarchieComponent implements OnInit {
  Data: Array<any> = [{ Name: 'amin', Parent: [''] }];
  nodeSelected = null;
  refresh = true;
  DataClone = [];
  diagramCode = 1;
  layoutMode = 'HierarchicalTree';
  emptyDiagram;
  @ViewChild('diagram') diagram: DiagramComponent;
  constructor(
    public dialog: MatDialog,
    private generalService: GeneralService
  ) {}
  // Loading the data
  public data: Object = this.getDataForNode();

  getDataForNode() {
    return {
      id: 'Name',
      parentId: 'Parent',
      dataSource: new DataManager(this.Data as any),
      //binds the external data with node
      doBinding: (nodeModel: NodeModel, data: DataInfo, diagram: Diagram) => {
        nodeModel.annotations = [
          {
            id: data['Name'],
            content: data['Name'],
            style: { color: 'white', fontSize: 18, textAlign: 'Center' },
          },
        ];
      },
    };
  }
  // setting up connectors (arrows)
  public connDefaults(connector: ConnectorModel): void {
    connector.type = 'Orthogonal';
    connector.style.strokeColor = '#4d4d4d';
    connector.targetDecorator.shape = 'None';
  }

  public tool: DiagramTools = DiagramTools.None;
  public snapSettings: SnapSettingsModel = {
    constraints: SnapConstraints.All,
  };
  public layout: Object = {
    type: this.layoutMode,
    horizontalSpacing: 40,
    verticalSpacing: 40,
    margin: { top: 250, left: 0, right: 0, bottom: 0 },
  };

  // selecting node
  public selectionChange(args: ISelectionChangeEventArgs): void {
    if (args.state === 'Changing') {
      if (args.newValue.length == 1) {
        const d: any = args.newValue[0];
        this.nodeSelected = d.data;
      } else if (args.newValue.length < 1) {
        if (this.nodeSelected) {
          this.Data = cloneArray(this.DataClone);
          this.refreshDiagram();
        }
        this.nodeSelected = null;
      }
    }
  }
  public connectionChange(args: IEndChangeEventArgs): void {
    if (args.state === 'Completed') {
      if (!args.connector.targetID || !args.connector.sourceID) {
        args.cancel = true;
      }
    }
  }

  public getNodeDefaults(obj: NodeModel, diagram: Diagram): NodeModel {
    const fill = obj.data['Parent'][0] == '' ? '#DD1111' : '#B14F5D';
    obj.width = 150;
    obj.height = 50;
    obj.offsetX = 100;
    obj.shape = { type: 'Basic', shape: 'Rectangle', cornerRadius: 10 };
    obj.style = { strokeWidth: 1, strokeColor: '#CACACA', fill };
    return obj;
  }

  public getConnectorDefaults(
    connector: ConnectorModel,
    diagram: Diagram
  ): ConnectorModel {
    connector.type = 'Orthogonal';
    connector.style.fill = '#707070';
    connector.style.strokeColor = '#707070';
    connector.targetDecorator = {
      style: {
        strokeColor: '#707070',
        fill: '#707070',
      },
    };
    return connector;
  }
  openDialog(): void {
    const dialogRef = this.dialog.open(HierarchieModifModalComponent, {
      width: '30%',
      data: this.nodeSelected,
    });

    dialogRef.afterClosed().subscribe((result) => {
      this.manageNewNodesUpdate(result);
    });
  }
  manageNoteUpdateFromSideBar() {
    // this.manageNewNodesUpdate();
  }
  ngOnInit() {
    /**
     * we will need the childs array
     * for each node so we can add on them later
     * Algorithm : For each node we check if it's
     * exist in any other node's parent array
     * if so we add it to the childs array
     */

    this.refresh = false;
    // TODO : CHANGE LATER
    this.generalService
      .getHierarchieFromNode(this.diagramCode)
      .subscribe((res: any) => {
        if (!res.ArtAxe[0].id) {
          this.emptyDiagram = true;
          return;
        }
        this.Data = this.structureApiData(res.ArtAxe);
        // setting up childs
        this.Data.forEach((element) => {
          element.childs = [];
          this.Data.forEach((secondElement) => {
            if (secondElement.Parent.includes(element.Name)) {
              element.childs.push(secondElement.Name);
            }
          });
        });
        this.DataClone = cloneArray(this.Data);
        this.refreshDiagram();
        this.refresh = true;
      });
  }
  refreshDiagram() {
    // we update the data object so the
    // diagramm refreches
    this.data = this.getDataForNode();
  }
  existInDiagram(value) {
    let b = false;
    this.DataClone.forEach((el) => {
      if (el['Parent'].includes(value) || el['childs'].includes(value))
        b = true;
    });
    return b;
  }
  changeLayoutMode(mode) {
    this.layoutMode = mode;

    this.layout = {
      type: this.layoutMode,
      horizontalSpacing: 40,
      verticalSpacing: 40,
      margin: { top: 250, left: 0, bottom: 0 },
    };
  }
  structureApiData(data) {
    return this.groupBy(data, 'ArtAxe_Chlid', 'ArtAxe_Parent');
  }
  groupBy(arr, by, group) {
    const newObj = arr.reduce(function (acc, currentValue) {
      if (!acc[currentValue[by]]) {
        acc[currentValue[by]] = [];
      }
      acc[currentValue[by]].push(currentValue[group]);
      return acc;
    }, {});

    let returnValue = [];
    for (const property in newObj) {
      returnValue.push({ Name: property, Parent: newObj[property] });
    }
    return returnValue;
  }

  manageNewNodesUpdate(result) {
    // if the user blured or the modal
    if (!result) {
      this.DataClone = cloneArray(this.Data);
      return;
    }
    let obsArray = [];
    result.childs.forEach((child) => {
      this.DataClone.forEach((node) => {
        if (result.Name == node.Name && !node.childs.includes(child)) {
          const newNode = {
            child,
            parent: result.Name,
            type: 0,
            code: this.diagramCode,
          };
          obsArray.push(this.generalService.addHierarchieNode(newNode));
        }
      });
    });
    result.Parent.forEach((parents) => {
      this.DataClone.forEach((node) => {
        if (result.Name == node.Name && !node.Parent.includes(parents)) {
          const newNode = {
            child: result.Name,
            parent: parents,
            type: 0,
            code: this.diagramCode,
          };
          obsArray.push(this.generalService.addHierarchieNode(newNode));
          if (!this.existInDiagram(parent)) {
            const newParentNode = {
              child: parents,
              parent: '',
              type: 0,
              code: this.diagramCode,
            };
            obsArray.push(this.generalService.addHierarchieNode(newParentNode));
          }
        }
      });
    });

    forkJoin(obsArray).subscribe((res) => {
      /**
       * the new node will be added automaticly in the
       * data so we can't tell if the each node is new or
       * old , a solution for that was to make a clone for the
       * data and compare between two objects
       * Data -> realtime object that updates
       * DataClone -> objects that updates on save
       */
      this.Data = this.DataClone;
      this.ngOnInit();
      // refresh the diagramm
      this.refreshDiagram();
    });
  }
}
